<mat-tab-group class="reports-graph-tabs">
  <mat-tab *ngFor="let graph of reportMetadata.graphs; let i = index" [label]="graph.title">
    <div class="reports-graph">
      <ngx-charts-line-chart
        *ngIf="graph.type === 'line'"
        [results]="graphData[i]"
        [legend]="true"
        [legendPosition]="LegendPosition.Right"
        [xAxis]="true"
        [yAxis]="true"
        [xAxisTickFormatting]="graph.xAxisFormatFunction"
        [yAxisTickFormatting]="graph.yAxisFormatFunction"
      ></ngx-charts-line-chart>

      <app-bar-vertical-2d-ref-lines
        *ngIf="graph.type === 'bar'"
        [results]="graphData[i]"
        [legend]="true"
        [legendPosition]="LegendPosition.Right"
        [xAxis]="true"
        [yAxis]="true"
        [xAxisTickFormatting]="graph.xAxisFormatFunction"
        [yAxisTickFormatting]="graph.yAxisFormatFunction"
        [barPadding]="0"
        [groupPadding]="1"
        [referenceLines]="graph.referenceLines || [{ value: 10, label: 'Reference', color: 'orange' }]"
      ></app-bar-vertical-2d-ref-lines>
    </div>
  </mat-tab>
</mat-tab-group>